import React, { Component } from 'react';
import { Spring, animated } from 'react-spring';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import SpritesheetAnim from '../../components/SpritesheetAnim';
import ScrollAnimation from '../../components/ScrollAnimation';
import DragonAnimation from '../../components/DragonAnimation';
import AttackAnimation from '../../components/AttackAnimation';
import BottleAnimation from '../../components/BottleAnimation';
import GuitarPlayerSpriteSheet from '../../assets/island/guitarplayer-row.png';
import MagicBookSpriteSheet from '../../assets/island/magicbook-row.png';
import ChestSpriteSheet from '../../assets/island/chest-row.png';
import classAttackConfigs from '../../constants/classAttackConfigs';
import animalsConfigs from '../../constants/animalsConfigs';

import {
  guitarPlayerConfigs,
  magicBookConfigs,
  chestConfigs,
} from '../../constants/spriteConfigs';

import './styles.css';

const propTypes = {
  speedValues: PropTypes.oneOfType([PropTypes.object]),
  startAttack: PropTypes.bool.isRequired,
  scrollPos: PropTypes.number,
  showAttackButton: PropTypes.func.isRequired,
  handleStartAttack: PropTypes.func.isRequired,
  charClass: PropTypes.string.isRequired,
  shouldExplode: PropTypes.bool.isRequired,
  changeStateEmail: PropTypes.func.isRequired,
  resumeAnim: PropTypes.bool.isRequired,
  attackButtonAtive: PropTypes.bool.isRequired,
};

const defaultProps = {
  speedValues: {},
  scrollPos: 0,
};

export default class Island extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startScrollAnim: false,
      shouldMove: false,
      startDragonAnim: false,
      animals: animalsConfigs,
      showChestReward: false,
      activeAnimal: null,
      startBottleAnim: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      scrollPos, startAttack, charClass, shouldExplode, attackButtonAtive,
    } = this.props;
    const {
      startScrollAnim,
      shouldMove,
      startDragonAnim,
      activeAnimal,
    } = this.state;
    const startAnimScrollPos = isMobile ? 49000 : 47800;
    const startAnimDragonPos = isMobile ? 56000 : 55500;

    if (prevProps.startAttack !== startAttack && activeAnimal !== null) {
      if (charClass !== '' && startAttack) {
        this.handleClassAttack(charClass, activeAnimal, startAttack);
      }
    }

    if (
      prevProps.startAttack !== startAttack
      && !startAttack
      && shouldExplode
      && activeAnimal !== null
    ) {
      this.handleAnimalExplosion();
    }

    if (scrollPos > startAnimScrollPos && !shouldMove && !startScrollAnim) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ shouldMove: true });
    }

    if (scrollPos > startAnimDragonPos && !startDragonAnim) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ startDragonAnim: true });
    }

    if (prevProps.attackButtonAtive !== attackButtonAtive && !attackButtonAtive && !startAttack) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ activeAnimal: null });
    }
  }

  handleClassAttack = (charClass, selectedAnimal, startAttack) => {
    const selectedCharacter = classAttackConfigs.filter(
      character => character.name === charClass,
    );

    this.setState({
      animationName: selectedCharacter[0].attackType,
      target: selectedAnimal,
      startAttackDragonAnimation: startAttack,
    });
  };

  handleStartAttack = () => {
    const { handleStartAttack, shouldExplode } = this.props;
    const { activeAnimal } = this.state;

    if (shouldExplode && activeAnimal === 'dragon') {
      this.setState(
        {
          startAttackDragonAnimation: false,
          activeAnimal: null,
          animals: [],
          showChestReward: true,
        },
        () => this.handleStartChestAnim(),
      );
      return;
    }

    this.setState({ startAttackDragonAnimation: false }, () => handleStartAttack());
  };

  handleStoppedAnim = () => this.setState({ shouldMove: false, startScrollAnim: true });

  handleAttackDragon = () => {
    const { showAttackButton } = this.props;
    const { activeAnimal } = this.state;

    if (activeAnimal === null) {
      this.setState({ activeAnimal: 'dragon' }, () => showAttackButton(true));
    }
  };

  handleAnimalExplosion = () => {
    this.setState({
      animationName: 'explosion',
      target: 'dragon',
      startAttackDragonAnimation: true,
      shouldMove: true,
    });
  };

  handleStartChestAnim = () => {
    this.setState({ ChestAnim: true });
  };

  handleStoppedChestAnim = () => {
    this.setState({ ChestAnim: false, startBottleAnim: true });
    // show contact form
  };

  handleBottlePaused = () => {
    const { changeStateEmail } = this.props;

    changeStateEmail('prepare');
  };

  renderDragon = () => {
    const {
      startAttackDragonAnimation,
      startDragonAnim,
      animationName,
      target,
      animals,
    } = this.state;

    return animals.map(animal => {
      if (animal.id === 4) {
        return (
          <div key={animal.id} className="dragon-container">
            <DragonAnimation
              startAnim={startDragonAnim}
              onClick={this.handleAttackDragon}
            />
            {startAttackDragonAnimation ? (
              <AttackAnimation
                startAttack={startAttackDragonAnimation}
                handleStartAttack={this.handleStartAttack}
                animationName={animationName}
                target={target}
              />
            ) : null}
          </div>
        );
      }

      return false;
    });
  };

  render() {
    const { speedValues, scrollPos, resumeAnim } = this.props;
    const {
      startScrollAnim,
      shouldMove,
      showChestReward,
      animals,
      ChestAnim,
      startBottleAnim,
    } = this.state;

    return (
      <div className="scenario-5">
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.slow, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-1"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="guitarplayer-container">
                <SpritesheetAnim
                  ref={node => {
                    this.sprite = node;
                  }}
                  spritePath={GuitarPlayerSpriteSheet}
                  spriteConfigs={guitarPlayerConfigs}
                  loopAnim
                />
              </div>
              <div className="mountain-2" />
              <div className="mountain-3" />
              <div className="vulcan" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.normal, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-2"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="mountain-1" />
              <div className="mountain-4" />
              <div className="mountain-5" />
              <div className="mountain-6" />
              <div className="back-grass" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.fast, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-3`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="front-grass" />
              <div className="sec-exp-sign" />
              <div className="bush-1" />
              <div className="bush-2" />
              <div className="bush-3" />
              <div className="rock-1" />
              <div className="rock-2" />
              <div className="magicbook-container">
                <SpritesheetAnim
                  ref={node => {
                    this.sprite1 = node;
                  }}
                  spritePath={MagicBookSpriteSheet}
                  spriteConfigs={magicBookConfigs}
                  moveOnce={shouldMove}
                  hasStopped={this.handleStoppedAnim}
                />
              </div>
              <ScrollAnimation startAnim={startScrollAnim} />
              <div className="experience-sign" />
              <div className="dragon-sign" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.fast, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-4`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              {animals ? this.renderDragon() : null}
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.fast, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-5"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              {showChestReward ? (
                <div className={`${isMobile ? 'mobile' : ''} chest-container`}>
                  <SpritesheetAnim
                    ref={node => {
                      this.sprite2 = node;
                    }}
                    spritePath={ChestSpriteSheet}
                    spriteConfigs={chestConfigs}
                    moveOnce={ChestAnim}
                    hasStopped={this.handleStoppedChestAnim}
                  />
                </div>
              ) : null}
              <BottleAnimation
                startAnim={startBottleAnim}
                isPaused={this.handleBottlePaused}
                resumeAnim={resumeAnim}
              />
            </animated.div>
          )}
        </Spring>
      </div>
    );
  }
}

Island.propTypes = propTypes;
Island.defaultProps = defaultProps;
